import { render } from "./addPaid.vue?vue&type=template&id=1487ea1c&scoped=true"
import script from "./addPaid.vue?vue&type=script&lang=js"
export * from "./addPaid.vue?vue&type=script&lang=js"

import "./addPaid.vue?vue&type=style&index=0&id=1487ea1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1487ea1c"]])

export default __exports__